import React, {FunctionComponent} from 'react'
import styles from './StatusIno.module.scss'
interface Props {
   status: string,
   color: string,
}

const Infostatistics: FunctionComponent<Props> = (props) => {
    return <div className={styles.status}>
        <div style={{background:props.color}} className={styles.square}></div>
        <span>{props.status}</span>
    </div>
}
export default Infostatistics